<template>
	<transition name="modal-fade">
		<div v-if="modalActive" class="modal-bg" @mousedown.self="closeModal">
			<div aria-describedby="modalDescription" aria-labelledby="modalTitle" class="modal" role="dialog">
				<header class="modal-header">
					<slot name="modal-header"></slot>
					<a aria-label="Close modal" class="modal-close" title="Close modal" href="#" @click.prevent="closeModal"><i class="fas fa-times"></i></a>
				</header>
				<div class="modal-body" id="modalDescription">
					<slot name="modal-body"></slot>
				</div>
				<footer class="modal-footer">
					<slot name="modal-footer"></slot>
					<a class="btn btn-md btn-primary" href="#" @click.prevent="closeModal">Cancel</a>
				</footer>
			</div>
		</div>
	</transition>
</template>

<script>

import {eventBus} from "../../app";

export default {
	name: "Modal",
	props: {
		modalName: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			name: this.modalName,
			modalActive: false
		}
	},
	created() {
		let vm = this;
		eventBus.$on('onModalOpen_' + vm.name, function () {
			vm.modalActive = true;

			eventBus.$emit('onModalOpened_' + vm.name);
		});
		eventBus.$on('onModalClose_' + vm.name, function () {
			eventBus.$emit('onModalClosed_' + vm.name);
			vm.closeModal();
		});
	},
	beforeDestroy() {
		let vm = this;
		eventBus.$off('onModalOpen_' + vm.name);
	},
	methods: {
		closeModal: function () {
			let vm = this;

			eventBus.$emit('onModalClose');

			vm.modalActive = false;
		}
	}
}

</script>

<style scoped>

</style>
